import React from 'react';
import StockLess from 'components/Tvendo/Article/Operations/StockLess/List';

export default function () {
  return <StockLess />;
}
